import { Body, Controller, Post, Req, Request, UploadedFile, UseInterceptors } from '@nestjs/common';
import { SaleorderService } from './saleorder.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiBody, ApiConsumes, ApiTags } from '@nestjs/swagger';
import { SaleOrderDto, SoViewRequestDto } from './dto/sale-order.dto';
import { SaleOrderResponse } from './dto/sale-order-response';
import { Cron } from '@nestjs/schedule';
import { AllSaleOrdersTrackResponseModel, SaleOrderDetailsResponse, SaleOrderDetailViewInfoResponseModel, SaleOrderDetailViewResponseModel, SaleOrderDropDownResponseModel, SaleOrderInfoResponseModel, SoNumbersResponseModel, SoNumbersModel, BomDetailsForIdResponseModel, GetAllBomDetailsResponseModel, BOMDetailViewResponse, SaleOrderDropDownDto, AllSaleOrdersDetailsResponseModel, GetAllBomDataResponseModel, SaleOrderItemsResponseModel, PlantInvoiceDetailsResponse, SaleOrderItemsDropDownResponseModel, BomUpdateRequest, ActiveSaleOrderWithItemDetailsResponseModel, ItemsDetailsResponseModel, BomItemActiveResponse, GetAllInvoiceDetailsResponse, AllInsuranceResponse, InsuranceResponse, GetSaleOrderInformationResponseModel, SoRequest, SoTrackResponseModel, SoInspectionResponseModel, SoInspectionUpdateResponse, RmBomResponse, SoAllInspectionsResponseModel, SoProductionResponseModel, SaleOrderItemsForSoDropDownResponseModel, SaleOrderItemsBySoIdReaponseModel, SORmBomResponse, AllSaleOrdersItemsDetailsResponseModel, CommonResponse, SoItemVariantResponse, PoNumberDropDownResponse, HlPercentageInfo, BomWithCountAndQuantityResponse, SoDropCntQtyResponse, SaleOrderItemsDropdownResponse, DummyPackBomItemsRequest, DocumentApprovalUpdateRequest, BomDetailsCreationResponseModel, SoItemDataResponse, BomTrackerForSoIdResponseModel, SoPackingStatusModel, saleOrderItemIdRequest, SaleOrderItemsDetailsResponseModel, TransferredSosFilterDto, SoTypeReq, SoFormSdfPrintDto, DomesticSalesReqDto, DomesticSalesFilterRequest, EnquiryReportFilterDto, DomesticSaleDetailedViewReq, ConditionsRequest, ProductGradeReportReq, OverDuePendingReq, scheduleOrderReport, ProductWiseTargetStockReq, ProductWiseStockReq } from '@gtpl/shared-models/sale-management';
import { SoViewResponseModel, AllSaleOrdersResponseModel, AllSoItemsResponseModel } from '@gtpl/shared-models/sale-management';
// import { AllSaleOrdersTrackResponseModel } from '@gtpl/shared-models/sale-management';
import { ItemsRequest, SaleOrderIdRequest, SaleOrderItemRequest, SaleOrderItemsCasesRequest, SaleOrderNumberRequest, SolifeCycleCategoryReq, StoreConsumptionItemQtyReq, StoreConsumptionItemsRequest } from './dto/sale-order-id.request';
import { SaleOrderTrackFilters } from './dto/sale-order-track.dto';
import { FileInterceptor } from '@nestjs/platform-express'
import { diskStorage } from 'multer';
import { extname, join } from 'path';
import { SaleOrderFileUploadResponse } from './dto/sale-order-file-upload-response';
import { SaleOrderUploadDto } from './dto/sale-order-file-uploa.dto';
import { BomCalculationService } from './bom-calculation.service';
import { BomPackingItemsDto } from './dto/packing-materials.dto';
import { CreateBomDTO } from './dto/create-bom.dto';
import { ItemCategoriesDropDownResponseModel, PlantIdRequest, BrandsRequest, CommonResponseArr } from '@gtpl/shared-models/masters';
import { SaleOrderItems } from './sale-order-items.entity';
import { SaleOrderItemsDTO } from './dto/sale-order-detail-view.dto';
import { isBoolean } from 'class-validator';
import { AllContainerStatusInfo, ContainerDispatchedToPlantResponse, ContainerStatusInfo, DispatchedToPlant, DocumentsApprovalResponse, FileUploadResponse, GetAllDocApprovalResponse, marksAndNoReq, SaleOrderRequest } from '@gtpl/shared-models/logistics';
import { PlantInvoiceDetailsRequest } from './dto/plant-invoice-details.request';
import { AllBlStatusInfo, SoContainerStatusUpdate } from '@gtpl/shared-models/logistics';
import { BomIdRequest } from './dto/bom-id-request';
import { PlantInvoiceDto } from './dto/plant-invoice.dto';
import { CustomerInvoiceService } from './customer-invoice.service';
import { InsuranceService } from './insurance.service';
import { InsuranceDto } from './dto/insurance-dto';
import { UpdateBomItemDto } from './dto/update-bom-item.dto';
import { BomItemRemovedQty } from './dto/remove-bom-assigned-qty.dto';
import { DocumentsService } from './documents.service';
import { UpdateDocumentUploadInfo } from './dto/document-approval-update.dto';
import { DocumentsUploadDto } from './dto/documents-upload.dto';
import { SoTrackRepository } from './repository/so-track-repository';
import { UpdateSoInspectionInfo } from './dto/so-inspection-update.dto';
import { ReProcessRequiredQty } from './dto/re-processing-required-qty.request';
import { FGStockData, SOVarientIdReq, SoIdRequest } from '@gtpl/shared-models/warehouse-management';
import { PlantInputRequest } from './dto/plant-input.request';
import { SoProductionDTO } from '@gtpl/shared-models/sale-management';
import { SoProductionService } from './so-production/so-production.service';
import { SoItemRequest } from './dto/so-item.request';
import { PayablesDashboardReq, RMFiltersRequest } from '@gtpl/shared-models/raw-material-procurement';
import { CountRequest } from './dto/count.request';
import { PackingRequiredResponse, SoComparisonDetailsResponse, SoCountDetailResponse, SoDeadStockDetailsResponse, SoLongRunResponse, SoProductCompleteNotShippedResponse, SoProductionStatusDetailsResponse, SoQntDetailResponse, SoStatusEnum, SoTopFiveResponse, SoYearWisePlanningDetailsResponse, SoYearWiseShippedDetailsResponse, UserDateRequest } from '@gtpl/shared-models/common-models';
import { ProductIdRequest } from './dto/product-id.request';
import { SaleOrderProductIdRequest } from './dto/sale-order-product.request';
import { SaleOrderIdsRequest } from './dto/sale-order-ids.request';
import { PoBomInfo } from './dto/po-bom-info';
import { SaleOrderGrossWeightRequest } from './dto/gross-weight-request';
import { SaleOrderItemsInfo } from './dto/sale-order-items-info.model';
import { RmBomLogUpdateRequset } from './dto/rmbomlog-update-req';
import { UnitRequest } from './dto/unit.id.request';
import { SgsTuvData } from './dto/sgs-tuv.dto';
import { EtdWiseDTO, LocationUpdateRequest, ProductConversionReq, RequiredPackingResponse } from '@gtpl/shared-models/procurement-management';
import { BomIdsRequest } from './dto/bom-ids.request';
import { PackingBomFilter } from './dto/packing-bom-filter.dto';
import { SOTransferDto } from './dto/so-transfer.dto';
import { GradePatternRequest } from './dto/grade-pattern-request';
import { SoPackingStatusRequest } from './so-packing-status.request';
import { UpdateCasesRequest } from './dto/upade-cases.request';
import { EndCustomerReq } from './dto/end-customer-req';
import { SubJobRequest } from './dto/sub-job-request';
import { UserDateReq } from './dto/user-date-request';
import { EndCustomerIdReq } from './dto/end-customer-id-req';
import { ProductBarcodeRequest } from './dto/product-barcode-request';
import { SoProcessTypeReq } from './dto/so-type-req';
import { SubJobSoRequest } from './dto/subjob-so.request';
import { DomesticSalesDto } from './dto/domestic-sales-dto';
import { DutyDrawBackDateReq, PaymentReq, RodteStatusReq, SaleReceiveReq } from '@gtpl/shared-models/finance';
import * as fs from 'fs-extra';
import { ShipmentDetailRequest } from '@gtpl/shared-models/warehouse-management';
import { AgingWiseReq } from './aging-wise-report.req';
import { PaybleComponentReq } from '@gtpl/shared-models/analytics-data';

@ApiTags('saleorder')
@Controller('saleorder')
export class SaleorderController {
  constructor(
    private saleOrderService: SaleorderService,
    private bomService: BomCalculationService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    private csInvService: CustomerInvoiceService,
    private insuranceService: InsuranceService,
    private docService: DocumentsService,
    private soTrackRepo: SoTrackRepository,
    private soProductionService: SoProductionService,


  ) { }

  /**
   * creates or a sale order
   * @param saleOrderDto sale oder DTO
   * @returns saleoderResponse
   */
  @Post('/createSubSaleOrder')
  async createSubSaleOrder(@Body() saleOrderDto: SaleOrderDto): Promise<SaleOrderResponse> {
    try {
      console.log(saleOrderDto);
      return await this.saleOrderService.createSubSaleOrder(saleOrderDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderResponse, error);
    }
  }

  @Post('/getReceivablesBillingData')
  async getReceivablesBillingData(@Body() req: DutyDrawBackDateReq): Promise<CommonResponse> {
    try {
      // Call the service method with the request body
      const result = await this.saleOrderService.getReceivablesBillingData(req);
      return result;
    } catch (err) {
      // Handle exceptions using the exception handler
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

  

  @Post('/getReceivablesAgingWiseData')
  async getReceivablesAgingWiseData(@Body() req:AgingWiseReq): Promise<CommonResponse> {
    try { 
      const result = await this.saleOrderService.getReceivablesAgingWiseData(req)
      return result
    } catch (err) {
      // Handle exceptions using the exception handler
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

      @Post('/getSuppliersData')
  async getSuppliersData(): Promise<CommonResponse> {
    try { 
      const result = await this.saleOrderService.getSuppliersData()
      return result
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

       @Post('/getVendorsData')
  async getVendorsData(): Promise<CommonResponse> {
    try { 
      const result = await this.saleOrderService.getVendorsData()
      return result
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

    @Post('/getFarmerAgingWiseReport')
  async getFarmerAgingWiseReport(@Body() req:AgingWiseReq): Promise<CommonResponse> {
    try { 
      const result = await this.saleOrderService.getFarmerAgingWiseReport(req)
      return result
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

      @Post('/getVendorAgingWiseReport')
  async getVendorAgingWiseReport(@Body() req:AgingWiseReq): Promise<CommonResponse> {
    try { 
      const result = await this.saleOrderService.getVendorAgingWiseReport(req)
      return result
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

  @Post('/createCreateSaleOrder')
  async createCreateSaleOrder(@Body() saleOrderDto: SaleOrderDto): Promise<CommonResponse> {
    try {
      console.log(saleOrderDto);
      return await this.saleOrderService.createSaleOrder(saleOrderDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }



  @Post('/saleOrderFileUpload')
  @ApiConsumes('multipart/form-data')
  @UseInterceptors(FileInterceptor('file', {
    limits: { files: 1 },
    storage: diskStorage({
      destination: 'sale-service/upload-files/sale-order-upload-files',
      filename: (req, file, callback) => {
        const name = file.originalname.split('.')[0];
        const fileExtName = extname(file.originalname);
        const randomName = Array(4)
          .fill(null)
          .map(() => Math.round(Math.random() * 16).toString(16))
          .join('');
        callback(null, `${name}${fileExtName}`);
      },
    }),
    fileFilter: (req, file, callback) => {
      if (!file.originalname.match(/\.(csv|xlsx|xls|pdf|zip)$/)) {
        return callback(new Error('Only xlsx,csv,xls,pdf files are allowed!'), false);
      }
      callback(null, true);
    },
  }))
  async saleOrderFileUpload(@UploadedFile() file, @Body() uploadData: SaleOrderUploadDto): Promise<SaleOrderFileUploadResponse> {
    try {
      console.log(file);
      console.log('**********************')
      console.log(uploadData.file)
      console.log(uploadData.saleOrderId,'uploadData.saleOrderId at 148');
      
      return await this.saleOrderService.updatePath(file.path, uploadData.saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderFileUploadResponse, error);
    }
  }


  @Post('/updateSaleOrder')
  async updateSaleOrder(@Body() saleOrderDto: SaleOrderDto, isUpdate = true): Promise<SaleOrderResponse> {
    try {
      console.log('update sale order');
      return await this.saleOrderService.createSaleOrder(saleOrderDto, isUpdate);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderResponse, error);
    }
  }

  @Post('/getAllSaleOrders')
  // @UseGuards(AuthGuard('jwt'))
  async getAllSaleOrders(): Promise<AllSaleOrdersResponseModel> {
    try {
      return await this.saleOrderService.getAllSaleOrders();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersResponseModel, error);
    }
  }
  @Post('/getAllSaleOrdersFHDashbard')
  // @UseGuards(AuthGuard('jwt'))
  async getAllSaleOrdersFHDashbard(@Body() req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      return await this.saleOrderService.getAllSaleOrdersFHDashbard(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersDetailsResponseModel, error);
    }
  }
  @Post('/getActiveSaleOrdersWithItemDetails')
  // @UseGuards(AuthGuard('jwt'))
  async getActiveSaleOrdersWithItemDetails(): Promise<ActiveSaleOrderWithItemDetailsResponseModel> {
    try {
      return await this.saleOrderService.getActiveSaleOrdersWithItemDetails();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ActiveSaleOrderWithItemDetailsResponseModel, error);
    }
  }
  @Post('/getSaleOrderInformationById')
  // @UseGuards(AuthGuard('jwt'))
  async getSaleOrderInformationById(@Body() saleOrderIdRequest: SaleOrderIdRequest,): Promise<GetSaleOrderInformationResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderInformationById(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GetSaleOrderInformationResponseModel, error);
    }
  }
  @Post('/getAllSaleOrdersDetails')
  async getAllSaleOrdersDetails(): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      return await this.saleOrderService.getAllSaleOrdersDetails();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersDetailsResponseModel, error);
    }
  }

  @Post('/getAllNotClosedSaleOrdersDetails')
  async getAllNotClosedSaleOrdersDetails(): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      return await this.saleOrderService.getAllNotClosedSaleOrdersDetails();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersDetailsResponseModel, error);
    }
  }

  @Post('/getAllBomTrackerInfo')
  async getAllBomTrackerInfo(@Body() req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      return await this.saleOrderService.getAllBomTrackerInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersDetailsResponseModel, error);
    }
  }

  @Post('/getAllClosedSaleOrdersDetails')
  async getAllClosedSaleOrdersDetails(@Body() req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      return await this.saleOrderService.getAllClosedSaleOrdersDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersDetailsResponseModel, error);
    }
  }

  @Post('/getSaleOrdersDropDownList')
  // @UseGuards(AuthGuard('jwt'))
  async getSaleOrdersDropDownList(): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrdersDropDownList();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }
  @Post('/getPackingSaleOrders')
  // @UseGuards(AuthGuard('jwt'))
  async getPackingSaleOrders(): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getPackingSaleOrders();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }
  /**
   * Warehouse API
   * @param plantInputRequest 
   * @returns 
   */
  @Post('/getAllActiveSaleOrders')
  async getAllActiveSaleOrders(@Body() plantInputRequest: PlantInputRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getAllActiveSaleOrders(plantInputRequest.plantId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }
  @Post('/getDummySaleOrders')
  async getDummySaleOrders(@Body() plantInputRequest: PlantInputRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getDummySaleOrders(plantInputRequest.plantId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }
  @Post('/getMTOSaleOrders')
  async getMTOSaleOrders(@Body() plantInputRequest: PlantInputRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getMTOSaleOrders(plantInputRequest.plantId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }
  // @Post('/updateSaleOrderStatus')
  // async updateSaleOrderStatus(@Body() saleOrderDto:SaleOrderDto,@Req() request:Request): Promise<SaleOrderResponse> {
  //   try {
  //     return await this.saleOrderService.createSaleOrder(saleOrderDto, true, request);
  //   } catch (error) {
  //     return this.applicationExceptionHandler.returnException(SaleOrderResponse, error);
  //   }
  // }
  @Post('/getAllSaleOrderItems')
  // @UseGuards(AuthGuard('jwt'))
  async getAllSaleOrderItems(): Promise<AllSoItemsResponseModel> {
    try {
      return await this.saleOrderService.getAllSaleOrderItems();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSoItemsResponseModel, error);
    }
  }

  @Post('/SoViewDetails')
  async getSoViewDetails(@Body() soViewRequestDto: SoViewRequestDto): Promise<SoViewResponseModel> {
    try {
      console.log('So-View-Controller' + soViewRequestDto.selectedSaleOrder);
      return await this.saleOrderService.getSoViewDetails(soViewRequestDto.selectedCustomer, soViewRequestDto.selectedEndCustomer, soViewRequestDto.selectedStatus, soViewRequestDto.selectedExpectedDate, soViewRequestDto.selectedSaleOrder);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoViewResponseModel, error);
    }
  }
  @Post('/getAllSaleOrdersTrackData')
  async getAllSaleOrdersTrackData(@Body() saleOrderTrackFilters: SaleOrderTrackFilters, @Req() request: Request): Promise<AllSaleOrdersTrackResponseModel> {
    try {
      // console.log('hhhiii');
      return await this.saleOrderService.getAllSaleOrdersTrackData(saleOrderTrackFilters, request);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersTrackResponseModel, error);
    }
  }

  @Post('/getSaleOrderDetailsById')
  async getSaleOrderDetailsById(@Body() saleOrderIdRequest: SaleOrderIdRequest, @Req() request: Request): Promise<SaleOrderDetailViewInfoResponseModel> {
    try {
      console.log(saleOrderIdRequest);
      return await this.saleOrderService.getSaleOrderDetailsById(saleOrderIdRequest, request);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDetailViewInfoResponseModel, error);
    }
  }
  @Post('/getSaleOrderDetailsBySaleNumber')
  async getSaleOrderDetailsBySaleNumber(@Body() saleOrderNumberRequest: SaleOrderNumberRequest, @Req() request: Request): Promise<SaleOrderDetailViewInfoResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderDetailsBySaleNumber(saleOrderNumberRequest, request);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDetailViewInfoResponseModel, error);
    }
  }
  /**
   * Warehouse API
   * @param saleOrderIdRequest 
   * @returns 
   */
  @Post('/getSaleOrderItemsForSo')
  async getSaleOrderItemsForSo(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderItemsForSoDropDownResponseModel> {
    try {
      console.log(saleOrderIdRequest);
      return await this.saleOrderService.getSaleOrderItemsForSo(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderItemsForSoDropDownResponseModel, error);
    }
  }
  @Post('/getSaleOrderItemsForSoId')
  async getSaleOrderItemsForSoId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderItemsDropdownResponse> {
    try {
      console.log(saleOrderIdRequest);
      return await this.saleOrderService.getSaleOrderItemsForSoId(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderItemsDropdownResponse, error);
    }
  }
  /**
   * Warehouse API
   * @param plantInputRequest 
   * @returns 
   */
  @Post('/getSaleOrdersAndItemsData')
  async getSaleOrdersAndItemsData(@Body() plantInputRequest: PlantInputRequest): Promise<SaleOrderItemsDropDownResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrdersAndItemsData(plantInputRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderItemsDropDownResponseModel, error);
    }
  }
  @Post('/updateReportingCases')
  async updateReportingCases(@Body() saleOrderItemsCasesRequest: SaleOrderItemsCasesRequest): Promise<boolean> {
    try {
      return await this.saleOrderService.updateReportingCases(saleOrderItemsCasesRequest);
    } catch (error) {
      // return this.applicationExceptionHandler.returnException(isBoolean, error);
    }
  }

  @Post('/getSaleOrderDetailsForId')
  async getSaleOrderDetailsForId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderDetailsResponse> {
    try {
      return await this.saleOrderService.getSaleOrderDetailsForId(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return error;
    }
  }

  @Post('/getPmStatus')
  async getPmStatus(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<SoTrackResponseModel> {
    try {
      return await this.saleOrderService.getPmStatus(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return error;
    }
  }



  @Post('/getSaleOrderDataById')
  async getSaleOrderDataById(@Body() saleOrderIdRequest: SaleOrderIdRequest, @Req() request: Request): Promise<SaleOrderResponse> {
    try {
      return await this.saleOrderService.getSaleOrderDataById(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderResponse, error);
    }
  }

  @Post('/getSaleOrderInformation')
  async getSaleOrderInformation(@Body() saleOrderIdRequest: SaleOrderIdRequest, @Req() request: Request): Promise<SaleOrderInfoResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderInformation(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderInfoResponseModel, error);
    }
  }

  /**
   * save bom details
   * @param bomData 
   * @returns 
   */
  @Post('/saveBomPackingMaterialDetails')
  async saveBomPackingMaterialDetails(@Body() bomData: CreateBomDTO) {
    try {
      return await this.bomService.saveBomPackingMaterialDetails(bomData);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderResponse, error);
    }
  }

  @Post('/getSoNumbers')
  async getSoNumbers(): Promise<SoNumbersResponseModel> {
    try {
      return await this.saleOrderService.getSoNumbers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoNumbersResponseModel, error);
    }
  }
  @Post('/getSoNumbersForInvoice')
  async getSoNumbersForInvoice(): Promise<SoNumbersResponseModel> {
    try {
      return await this.saleOrderService.getSoNumbersForInvoice();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoNumbersResponseModel, error);
    }
  }
  @Post('/getSoNumbersForPo')
  async getSoNumbersForPo(@Body() req?: UnitRequest): Promise<SoNumbersResponseModel> {
    try {
      return await this.saleOrderService.getSoNumbersForPo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoNumbersResponseModel, error);
    }
  }

  @Post('/getSoNumbersForPoFormUpdate')
  async getSoNumbersForPoFormUpdate(@Body() req?: PlantInputRequest): Promise<SoNumbersResponseModel> {
    try {
      return await this.saleOrderService.getSoNumbersForPoFormUpdate(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoNumbersResponseModel, error);
    }
  }



  /**
   * 
   * @param saleOrderIdRequest 
   * @returns 
   */
  @Post('/getAllBomDetailsForSoId')
  async getAllBomDetailsForSoId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<BomDetailsForIdResponseModel> {
    try {
      return await this.bomService.getAllBomDetailsForSoId(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomDetailsForIdResponseModel, error);
    }
  }

  /**
  * 
  * @param saleOrderIdRequest 
  * @returns 
  */
  @Post('/getAllBomDetailsForSoIdInPo')
  async getAllBomDetailsForSoIdInPo(@Body() saleOrderIdRequest: SaleOrderIdsRequest): Promise<BomDetailsForIdResponseModel> {
    try {
      return await this.bomService.getAllBomDetailsForSoIdInPo(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomDetailsForIdResponseModel, error);
    }
  }


  @Post('/BomDetailsForSoInPackingBom')
  async BomDetailsForSoInPackingBom(@Body() bomReq: BomIdsRequest): Promise<BomDetailsForIdResponseModel> {
    try {
      return await this.bomService.BomDetailsForSoInPackingBom(bomReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomDetailsForIdResponseModel, error);
    }
  }

  @Post('/getItemsDetails')
  async getItemsDetails(@Body() itemRequest: ItemsRequest): Promise<ItemsDetailsResponseModel> {
    try {
      return await this.bomService.getItemsDetails(itemRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDetailsResponseModel, error);
    }
  }


  @Post('/getAllBomDetails')
  async getAllBomDetails(): Promise<GetAllBomDetailsResponseModel> {
    try {
      return await this.bomService.getAllBomDetails();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GetAllBomDetailsResponseModel, error);
    }
  }
  @Post('/getAllBomData')
  async getAllBomData(@Body() req: SaleOrderIdRequest): Promise<GetAllBomDataResponseModel> {
    try {
      return await this.bomService.getAllBomData(req.saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GetAllBomDataResponseModel, error);
    }
  }

  @Post('/getAllBomDetailsBySoId')
  async getAllBomDetailsBySoId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<ItemCategoriesDropDownResponseModel> {
    try {
      return await this.bomService.getAllBomDetailsBySoId(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemCategoriesDropDownResponseModel, error);
    }
  }

  @Post('/getBomItemsForSoId')
  async getBomItemsForSoId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<BomTrackerForSoIdResponseModel> {
    try {
      return await this.saleOrderService.getBomItemsForSoId(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomTrackerForSoIdResponseModel, error);
    }
  }

  /**
   * 
   * @param saleOrderIdRequest 
   * @returns 
   */
  @Post('/getAllBomDetailViewDataForSoId')
  async getAllBomDetailViewDataForSoId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<BOMDetailViewResponse> {
    try {
      // console.log('saleOrderIdRequest'+saleOrderIdRequest);
      return await this.bomService.getAllBomDetailViewDataForSoId(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BOMDetailViewResponse, error);
    }
  }

  @Post('/getSaleOrderDataForSoId')
  async getSaleOrderDataForSoId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderDropDownDto> {
    try {
      return await this.saleOrderService.getSaleOrderDataForSoId(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return error
    }
  }

  @Post('/getSaleOrderFewDetailsForSoId')
  async getSaleOrderFewDetailsForSoId(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderDropDownDto> {
    try {
      return await this.saleOrderService.getSaleOrderFewDetailsForSoId(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return error
    }
  }

  /**
   * Warehouse API
   * @param saleOrderItemRequest 
   * @returns 
   */
  @Post('/getSaleOrderItemDetailsBySoItemId')
  async getSaleOrderItemDetailsBySoItemId(@Body() saleOrderItemRequest: SaleOrderItemRequest): Promise<SaleOrderItemsBySoIdReaponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderItemDetailsBySoItemId(saleOrderItemRequest);
    } catch (error) {
      return error
    }
  }

  @Post('/updateContainerStatus')
  async updateContainerStatus(@Body() soContainerStatus: SoContainerStatusUpdate): Promise<boolean> {
    try {
      return await this.saleOrderService.updateContainerStatus(soContainerStatus);
    } catch (error) {
      return error
    }
  }

  @Post('/updateBlStatus')
  async updateBlStatus(@Body() soBlStatus: SoContainerStatusUpdate) {
    try {
      return await this.saleOrderService.updateBlStatus(soBlStatus);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllContainerStatusInfo, error);
    }
  }

  @Post('/updateSoStatusForBl')
  async updateSoStatusForBl(@Body() soStatusForBl: SoContainerStatusUpdate) {
    try {
      return await this.saleOrderService.updateSoStatusForBl(soStatusForBl);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllContainerStatusInfo, error);
    }
  }



  @Post('/getSoTrackInfo')
  async getSoTrackInfo(): Promise<AllContainerStatusInfo> {
    try {
      return await this.saleOrderService.getSoTrackInfo();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllContainerStatusInfo, error);
    }
  }

  /**
   * Get the details for plant invoce grid and detailed view
   * @param PlantInvoiceDetailsRequest
   */
  @Post('/getPlantInvoiceDetails')
  async getPlantInvoiceDetails(@Body() plantInvoiceDetailsRequest: PlantInvoiceDetailsRequest): Promise<PlantInvoiceDetailsResponse> {
    try {
      return await this.saleOrderService.getPlantInvoiceDetails(plantInvoiceDetailsRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PlantInvoiceDetailsResponse, error);
    }
  }

  @Post('/getInvoiceDetailsForPrint')
  async getInvoiceDetailsForPrint(@Body() plantInvoiceDetailsRequest: PlantInvoiceDetailsRequest): Promise<PlantInvoiceDetailsResponse> {
    try {
      return await this.saleOrderService.getInvoiceDetailsForPrint(plantInvoiceDetailsRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PlantInvoiceDetailsResponse, error);
    }
  }

  @Post('/getSoTrackBlStatusInfo')
  async getSoTrackBlStatusInfo(): Promise<AllBlStatusInfo> {
    try {
      return await this.saleOrderService.getSoTrackBlStatusInfo();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllBlStatusInfo, error);
    }
  }

  @Post('/updateBomStats')
  async updateBomStats(@Body() req: BomIdRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.updateBomStats(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/updatePackingBOM')
  async updatePackingBOM(@Body() req: BomUpdateRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.updatePackingBOMPOData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updatePackingBOMGRNData')
  async updatePackingBOMGRNData(@Body() req: BomUpdateRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.updatePackingBOMGRNData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updatePackingBOMAssignedData')
  async updatePackingBOMAssignedData(@Body() req: BomUpdateRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.updatePackingBOMAssignedData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/UpdateSoForPo')
  async UpdateSoForPo(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.UpdateSoForPo(saleOrderIdRequest.saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createPlantInvoice')
  async createPlantInvoice(@Body() invoiceDto: PlantInvoiceDto) {
    try {
      return await this.csInvService.createPlantInvoice(invoiceDto, false);
    } catch (err) {
      return err
    }
  }

  @Post('/updatePlantInvoice')
  async updatePlantInvoice(@Body() invoiceDto: PlantInvoiceDto) {
    try {

      return await this.csInvService.createPlantInvoice(invoiceDto, true);
    } catch (err) {
      return err
    }
  }

  @Post('/UpdateBomQty')
  async UpdateBomQty(@Body() req: BomUpdateRequest): Promise<boolean> {
    try {
      return await this.saleOrderService.UpdateBomQty(req);
    } catch (error) {
      return error
    }
  }

  @Post('/updateSoTrackPmStatus')
  async updateSoTrackPmStatus(@Body() req: SoRequest): Promise<boolean> {
    try {
      return await this.saleOrderService.updateSoTrackPmStatus(req);
    } catch (error) {
      return error
    }
  }



  @Post('/UpdateAssignedQty')
  async UpdateAssignedQty(@Body() req: BomUpdateRequest): Promise<boolean> {
    try {
      return await this.saleOrderService.UpdateAssignedQty(req);
    } catch (error) {
      return error
    }
  }



  @Post('/ActivateorDeactivateBom')
  async ActivateorDeactivateBom(@Body() req: BomIdRequest): Promise<BomItemActiveResponse> {
    try {
      return await this.bomService.ActivateorDeactivateBom(req);
    } catch (error) {
      return error
    }
  }


  /**
  * Get the details for plant invoce grid and detailed view
  */
  @Post('/getAllPlantInvoiceDetails')
  async getAllPlantInvoiceDetails(@Body() req:PlantInvoiceDetailsRequest): Promise<GetAllInvoiceDetailsResponse> {
    try {
      return await this.saleOrderService.getAllPlantInvoiceDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GetAllInvoiceDetailsResponse, error);
    }
  }

  @Post('/getAllFinancialYear')
  async getAllFinancialYear(): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getAllFinancialYear();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getAllFiles')
  async getAllFiles(): Promise<AllInsuranceResponse> {
    try {
      return await this.insuranceService.getAllFiles();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllInsuranceResponse, error);

    }
  }



  @Post('/insuranceUpload')
  @ApiConsumes('multipart/form-data')
  @UseInterceptors(FileInterceptor('file', {
    limits: { files: 1 },
    storage: diskStorage({
      destination: './upload-files/insurance-upload-files',
      filename: (req, file, callback) => {
        const name = file.originalname.split('.')[0];
        const fileExtName = extname(file.originalname);
        const randomName = Array(4)
          .fill(null)
          .map(() => Math.round(Math.random() * 16).toString(16))
          .join('');
        callback(null, `${name}-${randomName}${fileExtName}`);
      },
    }),
    fileFilter: (req, file, callback) => {
      if (!file.originalname.match(/\.(csv|xlsx|xls|pdf)$/)) {
        return callback(new Error('Only xlsx,csv,xls,pdf files are allowed!'), false);
      }
      callback(null, true);
    },
  }))
  async insuranceUpload(@UploadedFile() file, @Body() uploadData: SaleOrderUploadDto): Promise<InsuranceResponse> {
    try {
      const fileDto = new InsuranceDto();
      fileDto.originalname = file.originalname;
      fileDto.fileName = file.filename;
      fileDto.destination = file.destination;
      fileDto.filePath = file.path;
      fileDto.saleOrderId = uploadData.saleOrderId;
      return await this.insuranceService.CreateInsurance(fileDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(InsuranceResponse, error);
    }
  }

  @Post('/UpdateBomItemsData')
  async UpdateBomItemsData(@Body() req: UpdateBomItemDto): Promise<BomItemActiveResponse> {
    try {
      return await this.bomService.UpdateBomItemsData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomItemActiveResponse, error);
    }
  }

  @Post('/UpdateBomRemovedQty')
  async UpdateBomRemovedQty(@Body() req: BomItemRemovedQty): Promise<BomItemActiveResponse> {
    try {
      return await this.bomService.UpdateBomRemovedQty(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomItemActiveResponse, error);
    }
  }


  @Post('/getAllSoDocumentsInfo')
  async getAllSoDocumentsInfo(@Body() plantIdRequest: PlantIdRequest): Promise<GetAllDocApprovalResponse> {
    try {
      return await this.docService.getAllSoDocumentsInfo(plantIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GetAllDocApprovalResponse, error);
    }
  }

  @Post('/updateDocumentInfo')
  async updateDocumentInfo(@Body() docDto: UpdateDocumentUploadInfo): Promise<DocumentsApprovalResponse> {
    try {
      return await this.docService.updateDocumentInfo(docDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(DocumentsApprovalResponse, error);
    }
  }

  @Post('/approveDocument')
  async approveDocument(@Body() docDto: DocumentsUploadDto): Promise<DocumentsApprovalResponse> {
    try {
      return await this.docService.approveDocument(docDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(DocumentsApprovalResponse, error);
    }
  }

  @Post('updateContainerStatusReadyToBook')
  async updateContainerStatusReadyToBook(@Body() containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
    try {
      return this.saleOrderService.updateContainerStatusReadyToBook(containerInfo);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
    }
  }

  @Post('updateToOpenStatus')
  async updateToOpenStatus(@Body() containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
    try {
      return this.saleOrderService.updateToOpenStatus(containerInfo);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
    }
  }

  @Post('getReProcessingRequiredQuantity')
  async getReProcessingRequiredQuantity(@Body() req: ReProcessRequiredQty) {
    try {
      return this.bomService.getReProcessingRequiredQuantity(req);
    } catch (error) {
      return error;
    }
  }

  @Post('updateReProcessQty')
  async updateReProcessQty(@Body() reProcessStock: FGStockData) {
    try {
      return this.bomService.updateReProcessQty(reProcessStock);
    } catch (error) {
      return error;
    }
  }

  @Post('/getAllSoInspections')
  async getAllSoInspections(): Promise<SoAllInspectionsResponseModel> {
    try {
      return await this.saleOrderService.getAllSoInspections();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoAllInspectionsResponseModel, error);
    }
  }

  @Post('/updateSoInspectionInfo')
  async updateSoInspectionInfo(@Body() inspectionDto: UpdateSoInspectionInfo): Promise<SoInspectionUpdateResponse> {
    try {
      return await this.saleOrderService.updateSoInspectionInfo(inspectionDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoInspectionUpdateResponse, error);
    }
  }

  @Post('/updateSGSTUVData')
  async updateSGSTUVData(@Body() inspectionDto: SgsTuvData): Promise<SoInspectionUpdateResponse> {
    try {
      return await this.saleOrderService.updateSGSTUVData(inspectionDto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoInspectionUpdateResponse, error);
    }
  }


  @Post('/getRmBomData')
  async getRmBomData(@Body() req: RMFiltersRequest): Promise<RmBomResponse> {
    try {
      console.log(req)
      return await this.saleOrderService.getRmBomData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RmBomResponse, error);
    }
  }

  @Post('/createSoProduction')
  async createSoProduction(@Body() soProductionDto: SoProductionDTO, isUpdate = false): Promise<SoProductionResponseModel> {
    try {
      return await this.soProductionService.createSoProduction(soProductionDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoProductionResponseModel, error);
    }
  }

  @Post('/updateRmBomQuantity')
  async updateRmBomQuantity(): Promise<any> {
    try {
      return await this.saleOrderService.updateRmBomQuantity();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoProductionResponseModel, error);

    }
  }

  @Post('/getAllsaleordersBomdata')
  async getAllsaleordersBomdata(): Promise<SORmBomResponse> {
    try {
      return await this.saleOrderService.getAllsaleordersBomdata();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SORmBomResponse, error);
    }
  }
  @Post('/getPackingStyleDetails')
  async getPackingStyleDetails(@Body() saleOrderItemRequest: SaleOrderItemRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getPackingStyleDetails(saleOrderItemRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrderItemDetails')
  async getSaleOrderItemDetails(@Body() saleOrderItemRequest: SaleOrderItemRequest): Promise<AllSaleOrdersItemsDetailsResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderItemDetails(saleOrderItemRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersItemsDetailsResponseModel, error);
    }
  }
  @Post('/getEndCustomerDetails')
  async getEndCustomerDetails(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getEndCustomerDetails(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }


  @Post('/getVarientInfoForSoItem')
  async getVarientInfoForSoItem(@Body() req: SoItemRequest): Promise<SoItemVariantResponse> {
    try {
      return await this.saleOrderService.getVarientInfoForSoItem(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoItemVariantResponse, error);
    }
  }

  @Post('/getHlPercentage')
  async getHlPercentage(@Body() req: SoItemRequest): Promise<HlPercentageInfo> {
    try {
      return await this.saleOrderService.getHlPercentage(req);
    } catch (error) {
      return error;
    }
  }
  @Post('/getPoNumbers')
  async getPoNumbers(): Promise<PoNumberDropDownResponse> {
    try {
      return await this.saleOrderService.getPoNumbers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PoNumberDropDownResponse, error);
    }
  }

  @Post('/getSaleOrdersCountAndQuantity')
  async getSaleOrdersCountAndQuantity(@Body() inputReq: CountRequest): Promise<BomWithCountAndQuantityResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersCountAndQuantity(inputReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomWithCountAndQuantityResponse, error);
    }
  }

  @Post('/getSaleOrdersForCount')
  async getSaleOrdersForCount(@Body() inputReq: CountRequest): Promise<SoDropCntQtyResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersForCount(inputReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoDropCntQtyResponse, error);
    }
  }

  @Post('/getSaleOrdersForRMCount')
  async getSaleOrdersForRMCount(@Body() inputReq: CountRequest): Promise<SoDropCntQtyResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersForRMCount(inputReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoDropCntQtyResponse, error);
    }
  }


  @Post('/packingRequirementForMonthly')
  async packingRequirementForMonthly(): Promise<PackingRequiredResponse> {
    try {
      return await this.bomService.packingRequirementForMonthly();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(PackingRequiredResponse, error);
    }
  }


  @Post('/getSaleOrdersForProduct')
  async getSaleOrdersForProduct(@Body() inputReq: ProductIdRequest): Promise<SoNumbersResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrdersForProduct(inputReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoNumbersResponseModel, error);
    }
  }


  @Post('/getSaleOrderItemsForSoAndProduct')
  async getSaleOrderItemsForSoAndProduct(@Body() saleOrderIdRequest: SaleOrderProductIdRequest): Promise<SaleOrderItemsForSoDropDownResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderItemsForSoAndProduct(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderItemsForSoDropDownResponseModel, error);
    }
  }

  @Post('/saveDummyPackmaterial')
  async saveDummyPackmaterial(@Body() req: DummyPackBomItemsRequest): Promise<boolean> {
    try {
      return await this.saleOrderService.saveDummyPackmaterial(req);
    } catch (error) {
      return false
    }
  }
  @Post('/updateDocumentStatus')
  async updateDocumentStatus(@Body() req: DocumentApprovalUpdateRequest): Promise<CommonResponse> {
    try {
      return await this.docService.updateDocumentStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoNumbersForDummyPackAssignment')
  async getSoNumbersForDummyPackAssignment(@Body() req: BrandsRequest): Promise<SoItemDataResponse> {
    try {
      return await this.saleOrderService.getSoNumbersForDummyPackAssignment(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoItemDataResponse, error);
    }
  }

  @Post('/savePoBomItems')
  async savePoBomItems(@Body() req: PoBomInfo): Promise<BomDetailsCreationResponseModel> {
    try {
      return await this.bomService.savePoBomItems(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(BomDetailsCreationResponseModel, error);
    }
  }

  @Post('/updateGrossWeight')
  async updateGrossWeight(@Body() req: SaleOrderGrossWeightRequest[]): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateGrossWeight(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/addSoItem')
  async addSoItem(@Body() req: SaleOrderItemsInfo): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.addSoItem(req, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/updateSoItem')
  async updateSoItem(@Body() req: SaleOrderItemsInfo): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.addSoItem(req, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getCustInvoiceDetails')
  async getCustInvoiceDetails(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getCustInvoiceDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getDocumentApprovalStatus')
  async getDocumentApprovalStatus(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getDocumentApprovalStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSoInspectionDetails')
  async getSoInspectionDetails(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoInspectionDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateReproceesingQtyInBom')
  async updateReproceesingQtyInBom(@Body() req: RmBomLogUpdateRequset): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateReproceesingQtyInBom(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getAllSaleOrdersTrackDataNew')
  async getAllSaleOrdersTrackDataNew(@Body() saleOrderTrackFilters: SaleOrderTrackFilters): Promise<AllSaleOrdersTrackResponseModel> {
    try {
      return await this.saleOrderService.getAllSaleOrdersTrackData_new(saleOrderTrackFilters);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersTrackResponseModel, error);
    }
  }

  @Post('/getAllSaleOrderItemDetails')
  async getAllSaleOrderItemDetails(@Body() req: SaleOrderIdRequest): Promise<AllSoItemsResponseModel> {
    try {
      return await this.saleOrderService.getAllSaleOrderItemDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSoItemsResponseModel, error);
    }
  }

  @Post('/getSoItemDetailsForInProgress')
  async getSoItemDetailsForInProgress(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoItemDetailsForInProgress(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoItemDetailsForBackLog')
  async getSoItemDetailsForBackLog(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoItemDetailsForBackLog(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getNoOfRackPositionsForSO')
  async getNoOfRackPositionsForSO(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getNoOfRackPositionsForSO(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/updateSoTrackProdStatus')
  async updateSoTrackProdStatus(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateSoTrackProdStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/soCancel')
  async soCancel(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.soCancel(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoStatusBySoId')
  async getSoStatusBySoId(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoStatusBySoId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/PackingBomData')
  async PackingBomData(@Body() req: PackingBomFilter): Promise<RequiredPackingResponse> {
    try {
      return await this.bomService.PackingBomData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RequiredPackingResponse, error);
    }
  }

  @Post('/transferSo')
  async transferSo(@Body() req: SOTransferDto): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.transferSo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getBomDataById')
  async getBomDataById(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getBomDataById(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getProductForSoId')
  async getProductForSoId(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getProductForSoId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrdersForGradePattern')
  async getSaleOrdersForGradePattern(@Body() req: GradePatternRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersForGradePattern(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoPackingStatus')
  async getSoPackingStatus(@Body() req?: SoPackingStatusRequest): Promise<CommonResponse> {
    console.log(req)
    try {
      return await this.bomService.getSoPackingStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSoDropForSoPackStatusReport')
  async getSoDropForSoPackStatusReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.getSoDropForSoPackStatusReport(req);
    } catch (error) {
      return error;
    }
  }
  @Post('/getItemSubDropForSoPackStatusReport')
  async getItemSubDropForSoPackStatusReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.getItemSubDropForSoPackStatusReport(req);
    } catch (error) {
      return error;
    }
  }
  @Post('/getItemDropForSoPackStatusReport')
  async getItemDropForSoPackStatusReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.getItemDropForSoPackStatusReport(req);
    } catch (error) {
      return error;
    }
  }
  @Post('/soReport')
  async soReport(): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.soReport();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/totalSoData')
  async totalSoData(@Body() saleOrderTrackFilters: SaleOrderTrackFilters): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.totalSoData(saleOrderTrackFilters);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getEndCustDropForSoReport')
  async getEndCustDropForSoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getEndCustDropForSoReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getCountryDropForSoReport')
  async getCountryDropForSoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getCountryDropForSoReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getManfUintDropForSoReport')
  async getManfUintDropForSoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getManfUintDropForSoReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getDestinationDropForSoReport')
  async getDestinationDropForSoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getDestinationDropForSoReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getBrandDropForSoReport')
  async getBrandDropForSoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getBrandDropForSoReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getVariantDropForSoReport')
  async getVariantDropForSoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getVariantDropForSoReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/storeIssueDataMigration')
  async storeIssueDataMigration(): Promise<any> {
    try {
      return await this.saleOrderService.storeIssueDataMigration();
    } catch (error) {
      // return this.applicationExceptionHandler.returnException(any, error);
    }
  }
  @Post('/updateReportedAndDispatchCases')
  async updateReportedAndDispatchCases(@Body() req: UpdateCasesRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateReportedAndDispatchCases(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getTransferredSaleOrders')
  async getTransferredSaleOrders(): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getTransferredSaleOrders();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSkippedSoCount')
  async getSkippedSoCount(): Promise<any> {
    try {
      return await this.saleOrderService.getSkippedSoCount();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSaleOrderLifeCycleStatus')
  async getSaleOrderLifeCycleStatus(): Promise<any> {
    try {
      return await this.saleOrderService.getSaleOrderLifeCycleStatus();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSaleOrderUsage')
  async getSaleOrderUsage(): Promise<any> {
    try {
      return await this.saleOrderService.getSaleOrderUsage();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getLogisticsUsage')
  async getLogisticsUsage(): Promise<any> {
    try {
      return await this.saleOrderService.getLogisticsUsage();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrdersCounDetail')
  async getSaleOrdersCounDetail(@Body() reqObj: UserDateRequest): Promise<SoCountDetailResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersCounDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoCountDetailResponse, error);
    }
  }
  @Post('/getSaleOrdersQtyDetail')
  async getSaleOrdersQtyDetail(@Body() reqObj: UserDateRequest): Promise<SoQntDetailResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersQtyDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoQntDetailResponse, error);
    }

  }
  @Post('/getLongRunSaleOrdersDetail')
  async getLongRunSaleOrdersDetail(@Body() reqObj: UserDateRequest): Promise<SoLongRunResponse> {
    try {
      return await this.saleOrderService.getLongRunSaleOrdersDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoLongRunResponse, error);
    }
  }
  @Post('/getLongRunSoCount')
  async getLongRunSoCount(@Body() reqObj: UserDateRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getLongRunSoCount(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getTopFiveSaleOrdersDetail')
  async getTopFiveSaleOrdersDetail(@Body() reqObj: UserDateRequest): Promise<SoTopFiveResponse> {
    try {
      return await this.saleOrderService.getTopFiveSaleOrdersDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoTopFiveResponse, error);
    }
  }
  @Post('/getSaleOrdersComparisonDetail')
  async getSaleOrdersComparisonDetail(@Body() reqObj: UserDateRequest): Promise<SoComparisonDetailsResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersComparisonDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoComparisonDetailsResponse, error);
    }

  }

  @Post('/getSaleOrdersDeadStockDetail')
  async getSaleOrdersDeadStockDetail(@Body() reqObj: UserDateRequest): Promise<SoDeadStockDetailsResponse> {
    try {
      return await this.saleOrderService.getSaleOrdersDeadStockDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoDeadStockDetailsResponse, error);
    }

  }

  @Post('/getSaleOrderYearWisePlannedDetail')
  async getSaleOrderYearWisePlannedDetail(@Body() reqObj: UserDateReq): Promise<SoYearWisePlanningDetailsResponse> {
    try {
      return await this.saleOrderService.getSaleOrderYearWisePlannedDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoYearWisePlanningDetailsResponse, error);
    }

  }
  @Post('/getSaleOrderYearWiseShippedDetail')
  async getSaleOrderYearWiseShippedDetail(@Body() reqObj: UserDateRequest): Promise<SoYearWiseShippedDetailsResponse> {
    try {
      return await this.saleOrderService.getSaleOrderYearWiseShippedDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoYearWiseShippedDetailsResponse, error);
    }
  }

  @Post('/getSaleOrderProductionStatusDetail')
  async getSaleOrderProductionStatusDetail(@Body() reqObj: UserDateRequest): Promise<SoProductionStatusDetailsResponse> {
    try {
      return await this.saleOrderService.getSaleOrderProductionStatusDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoProductionStatusDetailsResponse, error);
    }
  }

  @Post('/getSoProductionCompleteNotShippedDetail')
  async getSoProductionCompleteNotShippedDetail(@Body() reqObj: UserDateRequest): Promise<SoProductCompleteNotShippedResponse> {
    try {
      return await this.saleOrderService.getSoProductionCompleteNotShippedDetail(reqObj);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoProductCompleteNotShippedResponse, error);
    }
  }

  @Post('/getSaleOrderItemDetailsForSoItemId')
  async getSaleOrderItemDetailsForSoItemId(@Body() saleOrderItemRequest: SaleOrderItemRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSaleOrderItemDetailsForSoItemId(saleOrderItemRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSOContainerStatus')
  async getSOContainerStatus(@Body() req: SoRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSOContainerStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getPackStyleForSoItem')
  async getPackStyleForSoItem(@Body() saleOrderItemRequest: SaleOrderItemRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getPackStyleForSoItem(saleOrderItemRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getTotalJobCases')
  async getTotalJobCases(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getTotalJobCases(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateSOStatus')
  async updateSOStatus(@Body() req: SoIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateSOStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/saledataDump')
  async saledataDump(): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.saledataDump();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/subJobReverse')
  async subJobReverse(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.subJobReverse(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }


  @Cron('* 1 * * *')
  @Post('/updateSalesLifeCycleStatus')
  async updateSalesLifeCycleStatus(): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateSalesLifeCycleStatus();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoLifeCycleStatusCount')
  async getSoLifeCycleStatusCount(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoLifeCycleStatusCount(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/endcustomerWiseMonthlySOCount')
  async endcustomerWiseMonthlySOCount(@Body() req: EndCustomerReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.endcustomerWiseMonthlySOCount(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/editSubJob')
  async editSubJob(@Body() req: SubJobRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.editSubJob(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoDropForSubJob')
  async getSoDropForSubJob(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoDropForSubJob(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getBrandsForSoId')
  async getBrandsForSoId(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getBrandsForSoId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/stockAdjustmentReport')
  async stockAdjustmentReport(): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.stockAdjustmentReport();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrderItemDetailsBySoId')
  async getSaleOrderItemDetailsBySoId(@Body() req: SaleOrderIdRequest): Promise<SaleOrderItemsDetailsResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderItemDetailsBySoId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getTransferredSosReport')
  async getTransferredSosReport(@Body() req?: TransferredSosFilterDto): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getTransferredSosReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrderDropDownInvoiceDone')
  async getSaleOrderDropDownInvoiceDone(@Body() req: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrderDropDownInvoiceDone(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getDummyItemsForStoreConsumption')
  async getDummyItemsForStoreConsumption(@Body() unitReq: UnitRequest): Promise<ItemsDetailsResponseModel> {
    try {
      return await this.bomService.getDummyItemsForStoreConsumption(unitReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDetailsResponseModel, error);
    }
  }

  @Post('/getItemsForStoreConsumption')
  async getItemsForStoreConsumption(@Body() req: StoreConsumptionItemsRequest): Promise<ItemsDetailsResponseModel> {
    try {
      return await this.bomService.getItemsForStoreConsumption(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDetailsResponseModel, error);
    }
  }

  @Post('/getSaleordersAbstractReport')
  async getSaleordersAbstractReport(@Body() saleOrderTrackFilters: SaleOrderTrackFilters): Promise<AllSaleOrdersTrackResponseModel> {
    try {
      return await this.saleOrderService.getSaleordersAbstractReport(saleOrderTrackFilters);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersTrackResponseModel, error);
    }
  }

  @Post('/getCustomersDataForCustomerId')
  async getCustomersDataForCustomerId(@Body() req: EndCustomerIdReq): Promise<AllSaleOrdersTrackResponseModel> {
    try {
      return await this.saleOrderService.getCustomersDataForCustomerId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersTrackResponseModel, error);
    }
  }
  @Post('/getProductBarcode')
  async getProductBarcode(@Body() req: ProductBarcodeRequest): Promise<AllSaleOrdersTrackResponseModel> {
    try {
      return await this.saleOrderService.getProductBarcode(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllSaleOrdersTrackResponseModel, error);
    }
  }


  @Post('/updateEdlDateInInvoiceDetail')
  async updateEdlDateInInvoiceDetail(@Body() req: EtdWiseDTO[]): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateEdlDateInInvoiceDetail(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }


  @Post('/getSoPoBrandDropDownList')
  async getSoPoBrandDropDownList(@Body() req?: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoPoBrandDropDownList(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getCurrentMonthSaleordersForIndentForm')
  async getCurrentMonthSaleordersForIndentForm(@Body() req: SoProcessTypeReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getCurrentMonthSaleordersForIndentForm(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getPackingItemsFormSoItem')
  async getPackingItemsFormSoItem(@Body() req: SoItemRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getPackingItemsFormSoItem(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getRequiredPMQtyForSoItem')
  async getRequiredPMQtyForSoItem(@Body() req: StoreConsumptionItemQtyReq): Promise<CommonResponse> {
    try {
      return await this.bomService.getRequiredPMQtyForSoItem(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getAllSoForAssignSo')
  async getAllSoForAssignSo(@Body() req: SoTypeReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getAllSoForAssignSo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSubJobRevisionCodeListData')
  async getSubJobRevisionCodeListData(@Body() req: SubJobSoRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSubJobRevisionCodeListData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSubSoData')
  async getSubSoData(@Body() req: SoItemRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSubSoData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/testWhatsapp')
  async testWhatsapp(): Promise<CommonResponse> {
    try {
      const req = {
        "messaging_product": "whatsapp",
        "to": "918790477753",
        "type": "template",
        "template": {
          "name": "hello_world",
          "language": {
            "code": "en_US"
          }
        }
      }
      return await this.saleOrderService.testWhatsapp(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateCodeListStatusInSoTrack')
  async updateCodeListStatusInSoTrack(@Body() saleOrderId: number): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateCodeListStatusInSoTrack(saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/sendMessage')
  async sendMessage(msg): Promise<any> {
    try {
      return await this.saleOrderService.sendMessage(msg);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getsoitemforIndent')
  async getsoitemforIndent(@Body() req?: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getsoitemforIndent(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getAllActiveSaleOrdersForCodeList')
  async getAllActiveSaleOrdersForCodeList(@Body() plantInputRequest: PlantInputRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getAllActiveSaleOrdersForCodeList(plantInputRequest.plantId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }
  @Post('/getTrimsItemsForSo')
  async getTrimsItemsForSo(@Body() req: SaleOrderIdRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.saleOrderService.getTrimsItemsForSo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }

  @Post('/updateBomPo')
  async updateBomPo(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateBomPo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/GetSoLifeCycleStatusForCategory')
  async GetSoLifeCycleStatusForCategory(@Body() req: SolifeCycleCategoryReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.GetSoLifeCycleStatusForCategory(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrdersForTransfers')
  async getSaleOrdersForTransfers(@Body() req: UnitRequest): Promise<SoNumbersResponseModel> {
    try {
      return await this.saleOrderService.getSaleOrdersForTransfers(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }

  @Post('/getPoNumberForSoId')
  async getPoNumberForSoId(@Body() req: SaleOrderIdRequest): Promise<SoNumbersResponseModel> {
    try {
      return await this.saleOrderService.getPoNumberForSoId(req.saleOrderId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }

  @Post('/updateProductConversionQty')
  async updateProductConversionQty(@Body() req: ProductConversionReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateProductConversionQty(req);
    } catch (error) {
      console.log(error)
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateAssignedAndRequiredQty')
  async updateAssignedAndRequiredQty(@Body() req:LocationUpdateRequest): Promise<CommonResponse> {
    try {
      return await this.bomService.updateAssignedAndRequiredQty(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getEditedSoItemData')
  async getEditedSoItemData(@Body() req:any): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getEditedSoItemData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getFormSdfPrint')
  async getFormSdfPrint(@Body() req:SoFormSdfPrintDto): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getFormSdfPrint(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getDeclarationForm')
  async getDeclarationForm(@Body() req:any): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getDeclarationForm(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrderItemsForGradingAssignSo')
  async getSaleOrderItemsForGradingAssignSo(@Body() saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderItemsForSoDropDownResponseModel> {
    try {
      console.log(saleOrderIdRequest);
      return await this.saleOrderService.getSaleOrderItemsForGradingAssignSo(saleOrderIdRequest);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderItemsForSoDropDownResponseModel, error);
    }
  }

  @Post('/getDummySo')
  async getDummySo(): Promise<CommonResponse> {
    try {
      // console.log(saleOrderIdRequest);
      return await this.saleOrderService.getDummySo();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getDomesticSalesGrid')
  async getDomesticSalesGrid(): Promise<CommonResponse> {
    try {
      // console.log(saleOrderIdRequest);
      return await this.saleOrderService.getDomesticSalesGrid();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getDomesticSalesDataForForm')
  @ApiBody({type:DomesticSalesReqDto})
  async getDomesticSalesDataForForm(@Body() req: DomesticSalesReqDto): Promise<CommonResponse> {
    try {
      // console.log(saleOrderIdRequest);
      return await this.saleOrderService.getDomesticSalesDataForForm(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createDomesticSales')
  @ApiBody({type:DomesticSalesDto})
  async createDomesticSales(@Body()createDto:any):Promise<CommonResponse>{
  try{
  return await this.saleOrderService.createDomesticSales(createDto)
  }catch (err){
  return this.applicationExceptionHandler.returnException(CommonResponse,err)
  }
  }

  @Post('/updateDomesticSale')
  // @ApiBody({ type: [DomesticSalesDto] })
  async updateDomesticSale(@Body() domesticSaleTypeDto: any, isUpdate: boolean = false): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.updateDomesticSale(domesticSaleTypeDto);
    } catch (error) {
      console.log(error)
      return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }

}

@Post('/getDomesticSalesDataInView')
async getDomesticSalesDataInView(@Body() req: DomesticSalesFilterRequest): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getDomesticSalesDataInView(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getEndCustomersData')
async getEndCustomersData(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getEndCustomersData();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getAllProducts')
async getAllProducts(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getAllProducts();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getAllUnits')
async getAllUnits(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getAllUnits();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getAllUnitManufacturing')
async getAllUnitManufacturing(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getAllUnitManufacturing();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getDomesticSalesDetailedView')
@ApiBody({type:DomesticSaleDetailedViewReq})
async getDomesticSalesDetailedView(@Body() req: DomesticSaleDetailedViewReq): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getDomesticSalesDetailedView(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getEnquiryManagementReport')
@ApiBody({type:EnquiryReportFilterDto})

async getEnquiryManagementReport(@Body() req:EnquiryReportFilterDto): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getEnquiryManagementReport(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getEnquiryManagementReportProductData')
async getEnquiryManagementReportProductData(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getEnquiryManagementReportProductData();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}


@Post('/getAllEnquiryNumbers')
async getAllEnquiryNumbers(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getAllEnquiryNumbers();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}


@Post('/getInvoiceNumberData')
    async getInvoiceNumberData(): Promise<CommonResponse> {
      try {
        
        return await this.csInvService.getInvoiceNumberData();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }


    @Post('/invoiceFileUpload')
@UseInterceptors(FileInterceptor('file', {
    limits: { files: 1 },
    storage: diskStorage({
        destination: async (req, file, callback) => {
            const uploadDir = join(__dirname, '../../../../', '/tally-integration/invoice-files/');
            // Check if the directory exists, if not, create it
            if (!(await fs.pathExists(uploadDir))) {
                try {
                    await fs.ensureDir(uploadDir);
                } catch (err) {
                    console.error('Error creating directory:', err);
                }
            }
            callback(null, uploadDir);
        },
        filename: (req, file, callback) => {
            const name = file.originalname.split('.')[0];
            const fileExtName = extname(file.originalname);
            const randomName = Array(4)
                .fill(null)
                .map(() => Math.round(Math.random() * 16).toString(16))
                .join('');
            callback(null, `${name}-${randomName}${fileExtName}`);
        },
    }),
    fileFilter: (req, file, callback) => {
        if (!file.originalname.match(/\.(csv|xlsx|xls|pdf|zip)$/)) {
            return callback(new Error('Only csv, xlsx, xls, pdf files are allowed!'), false);
        }
        callback(null, true);
    },
}))
    async invoiceFileUpload(@UploadedFile() file, @Body() uploadData: any): Promise<FileUploadResponse> {
        console.log(file, '****');
        try {
            return await this.csInvService.updatePath(file.path, file.filename, uploadData.invoiceId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FileUploadResponse, error);
        }
    }

@Post('/updateColletion')
async updateColletion(@Body() req:PaymentReq): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.updateColletion(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/updateDdb')
async updateDdb(@Body() req:PaymentReq): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.updateDdb(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getGrossFrozenForInvoiceLogistics')
// @UseGuards(AuthGuard('jwt'))
async getGrossFrozenForInvoiceLogistics(): Promise<CommonResponse> {
  try {
    return await this.saleOrderService.getGrossFrozenForInvoiceLogistics();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getConditionsBasedLogistics')
async getConditionsBasedLogistics(@Body() req:ConditionsRequest): Promise<CommonResponse> {
  try {
    return await this.saleOrderService.getConditionsBasedLogistics(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

  @Post('/getSaleOrderItemsBySaleOrderId')
  async getSaleOrderItemsBySaleOrderId(@Body() req:SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSaleOrderItemsBySaleOrderId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSoItemPackStyle')
  async getSoItemPackStyle(@Body() req:SOVarientIdReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getSoItemPackStyle(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getLinerAddressForIsfWorksheet')
  async getLinerAddressForIsfWorksheet(@Body() req:SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getLinerAddressForIsfWorksheet(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/updateRodtepStatus')
  async updateRodtepStatus(@Body() req:RodteStatusReq): Promise<CommonResponse> {
    try {
      // console.log(saleOrderIdRequest);
      return await this.saleOrderService.updateRodtepStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getShipmentDetailsReport')
  async getShipmentDetailsReport(@Body() req:ShipmentDetailRequest):Promise<CommonResponse>{
    try{
      return await this.saleOrderService.getShipmentDetailsReport(req)
    }catch (error)
    {
      return this.applicationExceptionHandler.returnException(CommonResponse,error)
    }
  }

  @Post('/getCustomerPoForShipmentDetailReport')
  async getCustomerPoForShipmentDetailReport(@Body() req:{unitId?:number}):Promise<CommonResponse>{
    try{
      return await this.saleOrderService.getCustomerPoForShipmentDetailReport(req)
    }catch (error)
    {
      return this.applicationExceptionHandler.returnException(CommonResponse,error)
    }
  }

  @Post('/getBrandForShipmentDetailReport')
  async getBrandForShipmentDetailReport(@Body() req:{unitId?:number}):Promise<CommonResponse>{
    try{
      return await this.saleOrderService.getBrandForShipmentDetailReport(req)
    }catch (error)
    {
      return this.applicationExceptionHandler.returnException(CommonResponse,error)
    }
  }

  @Post('/getInvoiceForShipmentDetailReport')
  async getInvoiceForShipmentDetailReport(@Body() req:{unitId?:number}):Promise<CommonResponse>{
    try{
      return await this.saleOrderService.getInvoiceForShipmentDetailReport(req)
    }catch (error)
    {
      return this.applicationExceptionHandler.returnException(CommonResponse,error)
    }
  }

  @Post('/getPendingOrdersReport')
    async getPendingOrdersReport(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.saleOrderService.getPendingOrdersReport(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    

    @Post('/getShippedOrdersReport')
    async getShippedOrdersReport(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.saleOrderService.getShippedOrdersReport(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getDistinctPoNumbers')
    async getDistinctPoNumbers(@Body() req: {unitId?:number}): Promise<CommonResponse> {
        try {
            return await this.saleOrderService.getDistinctPoNumbers(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getBuyerWiseOrdersReport')
    async getBuyerWiseOrdersReport(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.saleOrderService.getBuyerWiseOrdersReport(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getCompleteEnquiryManagementReport')    
    async getCompleteEnquiryManagementReport(@Body() req:EnquiryReportFilterDto): Promise<CommonResponse> {
      try {
        return await this.saleOrderService.getCompleteEnquiryManagementReport(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }

    @Post('/getBuyerForEnqReport')
    async getBuyerForEnqReport(): Promise<CommonResponse> {
      try {
        // console.log(saleOrderIdRequest);
        return await this.saleOrderService.getBuyerForEnqReport();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }

    @Post('/getAgentForEnqReport')
    async getAgentForEnqReport(): Promise<CommonResponse> {
      try {
        // console.log(saleOrderIdRequest);
        return await this.saleOrderService.getAgentForEnqReport();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }

    @Post('/getSalePersonForEnqReport')
    async getSalePersonForEnqReport(): Promise<CommonResponse> {
      try {
        // console.log(saleOrderIdRequest);
        return await this.saleOrderService.getSalePersonForEnqReport();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }

    @Post('/getEnquiryNumbers')
async getEnquiryNumbers(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getEnquiryNumbers();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

  @Post('/getAllSoInfo')
  async getAllSoInfo(): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getAllSoInfo();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/updateSaleReceived')
  async updateSaleReceived(@Body() req:SaleReceiveReq): Promise<CommonResponse> {
 
    try {
      return await this.saleOrderService.updateSaleReceived(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

@Post('/updateMarksAndNo')
async updateMarksAndNo(@Body() req:marksAndNoReq): Promise<CommonResponse> {
  try {
    return await this.saleOrderService.updateMarksAndNo(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/updateIgst')
async updateIgst(@Body() req:PaymentReq): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.updateIgst(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getProductGradeAnalysisReportData')
async getProductGradeAnalysisReportData(@Body() req:ProductGradeReportReq): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getProductGradeAnalysisReportData(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getProductGradeAnalysisReportProducts')
async getProductGradeAnalysisReportProducts(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getProductGradeAnalysisReportProducts();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getProductGradeAnalysisReportGrades')
async getProductGradeAnalysisReportGrades(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getProductGradeAnalysisReportGrades();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getOverduePendingOrderReport')
async getOverduePendingOrderReport(@Body() req:OverDuePendingReq): Promise<CommonResponse> {
  console.log(req, "######################3"); // Debugging log
  try {
    return await this.saleOrderService.getOverduePendingOrderReport(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getProductGradeAnalysisReportBuyers')
async getProductGradeAnalysisReportBuyers(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getProductGradeAnalysisReportBuyers();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getMonthWiseOverdueReport')
async getMonthWiseOverdueReport(@Body() req:OverDuePendingReq): Promise<CommonResponse> {
  console.log(req, "######################3"); // Debugging log
  try {
    return await this.saleOrderService.getMonthWiseOverdueReport(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getProductGradeAnalysisReportCountry')
async getProductGradeAnalysisReportCountry(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getProductGradeAnalysisReportCountry();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getPendingOrdersSummaryReportProduct')
async getPendingOrdersSummaryReportProduct(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getPendingOrdersSummaryReportProduct();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getPendingOrdersSummaryReportCount')
async getPendingOrdersSummaryReportCount(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getPendingOrdersSummaryReportCount();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getProductDropdownForScheduleorderReport')
async getProductDropdownForScheduleorderReport(): Promise<CommonResponse> {
  try {
    return await this.saleOrderService.getProductDropdownForScheduleorderReport();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getDataForScheduleorderReport')
async getDataForScheduleorderReport(@Body() req:scheduleOrderReport): Promise<CommonResponse> {
  try {
    return await this.saleOrderService.getDataForScheduleorderReport(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getProductWiseTargetStock')
@ApiBody({type:ProductWiseTargetStockReq})
async getProductWiseTargetStock(@Body() req:ProductWiseTargetStockReq): Promise<CommonResponse> {
  try {
    return await this.saleOrderService.getProductWiseTargetStock(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
@Post('/getSoQuantityAndPayablesDashboard')
async getSoQuantityAndPayablesDashboard(@Body() req:PayablesDashboardReq): Promise<CommonResponse> {
  try {
    return await this.saleOrderService.getSoQuantityAndPayablesDashboard(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

  @Post('/getTop10InvAmountVendorsList')
  async getTop10InvAmountVendorsList(@Body() req:PaybleComponentReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getTop10InvAmountVendorsList(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

    @Post('/getTop10OverdueInvAmountVendorsList')
  async getTop10OverdueInvAmountVendorsList(@Body() req:PaybleComponentReq): Promise<CommonResponse> {
    try {
      return await this.saleOrderService.getTop10OverdueInvAmountVendorsList(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getShortCodesForProductStockReport')
  async getShortCodesForProductStockReport(): Promise<CommonResponse> {
    try {
      // console.log(saleOrderIdRequest);
      return await this.saleOrderService.getShortCodesForProductStockReport();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGradesForProductStockReport')
  async getGradesForProductStockReport(): Promise<CommonResponse> {
    try {
      // console.log(saleOrderIdRequest);
      return await this.saleOrderService.getGradesForProductStockReport();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getProductWiseStockReport')
  async getProductWiseStockReport(@Body() req?:ProductWiseStockReq): Promise<CommonResponse> {
    try {
      // console.log(saleOrderIdRequest);
      return await this.saleOrderService.getProductWiseStockReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getSaleOrderVarients')
async getSaleOrderVarients(): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getSaleOrderVarients();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

  @Post('/cancelInvoice')
  async cancelInvoice(@Body() req: any) {
    try {
      return await this.csInvService.cancelInvoice(req);
    } catch (err) {
      return err
    }
  }

    @Post('/getInvoiceReportData')
async getInvoiceReportData(@Body() req?:any): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.saleOrderService.getInvoiceReportData(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
}


